import React from 'react';
import PropTypes from 'prop-types';
import { DataGrid, Grid, Input } from '../../../components';
import Masks from '../../../utils/masks';

const CalculoCompensacao = (props) => {
  if (!(props.requerimento.rendaMensalInicialSimulada ||
    props.requerimento.rendaMensalInicialReajustada ||
    props.requerimento.salarioMinimoDataInicioBeneficio ||
    props.requerimento.valorMedioBeneficios ||
    props.requerimento.percentualParticipacao || props.requerimento.proRataInicial)) {
    return null;
  }
  return (
    <DataGrid title="Cálculo da Compensação" icon="ico-calc" >
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Renda Mensal Simulada"
            onChange={e => props.handleChange(e, 'rendaMensalInicialSimulada')}
            value={props.requerimento.rendaMensalInicialSimulada ?
              props.requerimento.rendaMensalInicialSimulada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.rendaMensalInicialSimulada}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Renda Mensal Reajustada na Data de Benefício"
            onChange={e => props.handleChange(e, 'rendaMensalInicialReajustada')}
            value={props.requerimento.rendaMensalInicialReajustada ?
              props.requerimento.rendaMensalInicialReajustada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.rendaMensalInicialReajustada}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Salário Mínimo na Data de Início de Benefício"
            onChange={e => props.handleChange(e, 'salarioMinimoDataInicioBeneficio')}
            value={props.requerimento.salarioMinimoDataInicioBeneficio ?
              props.requerimento.salarioMinimoDataInicioBeneficio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.salarioMinimoDataInicioBeneficio}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Média na Data de Início de Benefício"
            onChange={e => props.handleChange(e, 'valorMedioBeneficios')}
            value={props.requerimento.valorMedioBeneficios ?
              props.requerimento.valorMedioBeneficios.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.valorMedioBeneficios}
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Renda Mensal de Compensação Previdenciária"
            onChange={e => props.handleChange(e, 'rendaMensalInicialCompensacaoPrevidenciaria')}
            value={props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria ?
              props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.rendaMensalInicialCompensacaoPrevidenciaria}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            participation
            mask={Masks.participation}
            number
            showMask={false}
            disabled
            label="Percentual de Participação do Regime Origem"
            onChange={e => props.handleChange(e, 'percentualParticipacao')}
            value={props.requerimento.percentualParticipacao}
          />
        </Grid>
        <Grid cols="4 4 4 4">
          <Input
            currency
            mask={Masks.currency}
            number
            showMask={false}
            disabled
            label="Pró-Rata Inicial"
            onChange={e => props.handleChange(e, 'proRataInicial')}
            value={props.requerimento.proRataInicial ?
              props.requerimento.proRataInicial.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) :
              props.requerimento.proRataInicial}
          />
        </Grid>
      </div>
    </DataGrid>
  );
};

CalculoCompensacao.propTypes = {
  handleChange: PropTypes.func.isRequired,
  requerimento: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default CalculoCompensacao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/CalculoCompensacao.jsx